/** RFC 0345: who shared a session with this person, if someone did. */

import type { AnyDocumentId } from '@automerge/automerge-repo/slim'
import type { WorldDoc } from '@mod/core/model'
import { useDocument } from '../world/repo/useDocument'
import { useSharingAccount } from './accountContext'

/** The inviter's name when the session is in this person's `sharedWithMe`,
 *  else undefined (sharing off, or the session is their own). */
export function useSharedSessionInviter(sessionId: string): string | undefined {
  const account = useSharingAccount()
  const [world] = useDocument<WorldDoc>(
    account?.opened.location.worldId as AnyDocumentId | undefined,
  )
  const entry = world?.sharedWithMe?.[sessionId]
  if (!entry || String(entry.kind) !== 'session') return undefined
  return String(entry.invitedBy ?? 'the owner')
}
